module.exports = __webpack_public_path__ + "static/away-95804ac94ef54278cc1ed9347a4e9f9f.png";